import { FunctionComponent } from "react";
import { useTranslation } from "next-i18next/pages";
import styles from "../../styles/home/Compliance.module.css";

interface ComplianceItem {
  title: string;
  text: string;
}

interface ComplianceProps {}

const complianceIcons = [
  <svg
    key="dpa"
    className={styles.cardIcon}
    viewBox="0 0 64 64"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M32 5 53 13v16c0 14-8.8 24.9-21 30C19.8 53.9 11 43 11 29V13l21-8Z"
      stroke="currentColor"
    />
    <path d="m22 31 7 7 14-16" stroke="currentColor" />
  </svg>,
  <svg
    key="ropa"
    className={styles.cardIcon}
    viewBox="0 0 64 64"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <rect x="13" y="8" width="38" height="48" stroke="currentColor" />
    <path d="M21 21h22M21 31h22M21 41h14" stroke="currentColor" />
  </svg>,
  <svg
    key="toms"
    className={styles.cardIcon}
    viewBox="0 0 64 64"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M18 26V17a14 14 0 0 1 28 0v9" stroke="currentColor" />
    <rect x="11" y="25" width="42" height="32" stroke="currentColor" />
  </svg>,
  <svg
    key="ai-act"
    className={styles.cardIcon}
    viewBox="0 0 64 64"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="32" cy="32" r="22" stroke="currentColor" />
    <path d="M21 36c5-12 17-12 22 0" stroke="currentColor" />
  </svg>,
  <svg
    key="eu-region"
    className={styles.cardIcon}
    viewBox="0 0 64 64"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M12 22 32 9l20 13v29a4 4 0 0 1-4 4H16a4 4 0 0 1-4-4V22Z"
      stroke="currentColor"
    />
  </svg>,
  <svg
    key="transparency"
    className={styles.cardIcon}
    viewBox="0 0 64 64"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="32" cy="18" r="8" stroke="currentColor" />
    <circle cx="17" cy="46" r="8" stroke="currentColor" />
    <circle cx="47" cy="46" r="8" stroke="currentColor" />
  </svg>
];

const Compliance: FunctionComponent<ComplianceProps> = () => {
  const { t } = useTranslation("common");
  const items: ComplianceItem[] = t("homeModern.compliance.items", {
    returnObjects: true
  }) as ComplianceItem[];
  const titleLines: string[] = t("homeModern.compliance.titleLines", {
    returnObjects: true
  }) as string[];

  return (
    <section id="compliance" className={styles.section}>
      <div className={styles.header}>
        <div>
          <div className={styles.kicker}>
            {t("homeModern.compliance.kicker")}
          </div>
          <h2 className={styles.title}>
            {titleLines.map((line: string) => (
              <span key={line}>{line}</span>
            ))}
          </h2>
        </div>
        <p className={styles.description}>
          {t("homeModern.compliance.description")}
        </p>
      </div>

      <div className={styles.grid}>
        {items.map((item: ComplianceItem, index: number) => (
          <article key={item.title} className={styles.card}>
            {complianceIcons[index]}
            <h3 className={styles.cardTitle}>{item.title}</h3>
            <p className={styles.cardText}>{item.text}</p>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Compliance;
